<script setup lang="ts">
    import Login from "@/components/auth/forms/Login.vue";
    import useLiveChat from "@/helpers/composables/useLiveChat";
    import { Link } from "@inertiajs/vue3";
    import { inject } from "vue";
    import LoginIssueIcon from "@icons/issue_login_icon.svg";
    let route = inject("route");

    const { openLiveChat } = useLiveChat();
</script>

<template>
    <Login />
    <Link :href="route('web.forgot-password')" class="navigation authorization-forgot_password"
        >Forgot password</Link>
        <div class="authorization-issue_link">
            <LoginIssueIcon alt="issue icon" />
            <div class="authorization-issue_text paragraph-details">
                <span class="authorization-issue_link_span">Issues Logging In?</span> <a @click.prevent="openLiveChat({sessionStarted: true})" href="#" class="authorization-troubleshooting_link paragraph-details">Contact us for support</a>
            </div>
        </div>
</template>

<style scoped></style>
